export default __webpack_public_path__ + "static/rovo-multiple-indicators-dark-c21d6473613ac30314d4c279fd2e261e4626cd14f898f74ce15ab1f7a80238ca.png";